package kpt.core.database

import androidx.room3.RoomDatabaseConstructor

public actual object AppDatabaseConstructor : RoomDatabaseConstructor<AppDatabase> {
  actual override fun initialize(): AppDatabase = kpt.core.database.AppDatabase_Impl()
}
